<template>
  <router-view />
</template>

<script>
export default {
  name: 'ProductStorageCashRequestIndex'
}
</script>
